import { useEffect } from 'react';
import useIsFirstRender from './use-is-first-render';

// Runs the effect only when deps is updated, not on initial render
function useUpdateEffect(effect, deps) {
  const isFirst = useIsFirstRender();
  useEffect(() => {
    if (!isFirst) {
      return effect();
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
export default useUpdateEffect;